import React, {
  useState,
  useEffect,
} from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';
import {
  Card,
  Row,
  Col,
  Table,
  Spin,
} from 'antd';
import {
  PAGES,
  ROLES,
} from 'appconstants';
import RBAC from 'components/rbac';
import queryString from 'querystring';
import { SpButton } from 'components/DesignKit';
import { lynxConnectActions, lynxTenantDetailActions } from 'store/actions';
import AddNewLynxConnectLocation from './addNewLocation';

type Props = {
  // loading: boolean,
  test: boolean,
  // validator: Boolean,
  location: {
    pathname: string,
    search: string,
  },
  history: {
    push: Function,
  };
  selectedAccount: Object,
  // submitting: Boolean,
  lynxTenantDetails: Array,
  lynxConnectLocations: Array,
  lynxConnectLocationsTotalElements: Number,
  fetchLocations: Function,
  addNewLocation: Function,
  resetLocations: Function,
  fetchLynxTenantDetails: Function,
  lynxConnectLoading: Boolean,
};

const LynxConnectInvoices = (props: Props) => {
  const {
    // loading,
    // validator,
    selectedAccount,
    // submitting,
    test,
    history,
    location,
    lynxTenantDetails,
    lynxConnectLocations,
    lynxConnectLocationsTotalElements,
    fetchLocations,
    addNewLocation,
    resetLocations,
    fetchLynxTenantDetails,
    lynxConnectLoading,
  } = props;

  // reset the state variables
  useEffect(() => {
    resetLocations({});
    // get the lynx tentant details
    fetchLynxTenantDetails();
  }, []);

  const [pagination, setPagination] = useState({});
  const [modalVisibility, setModalVisibility] = useState(false);

  const getData = (query) => {
    const parsed = queryString.parse(query);
    const {
      pageNum,
      sortBy,
      direction,
    } = parsed;
    fetchLocations({ pageNum, sortBy, direction });
  };

  useEffect(() => {
    getData(location.search);
  }, [location, test, selectedAccount]);

  useEffect(() => {
    const parsed = queryString.parse(location.search);
    const currentPage = parsed.pageNum || 1;
    setPagination(existingElements => ({
      ...existingElements,
      total: lynxConnectLocationsTotalElements,
      current: parseInt(currentPage, 10),
      showTotal: total => `Total ${total} items`,
    }));
  }, [
    location.search,
    lynxConnectLocations,
    lynxConnectLocationsTotalElements,
  ]);

  const handleTableChange = (page, filters, sorter) => {
    const selectPageNumber = page.current;
    let params = `&pageNum=${selectPageNumber}`;

    if (sorter && sorter.order) {
      const sortDirection = sorter.order === 'ascend' ? 'ASC' : 'DESC';
      params += `&sortBy=${sorter.field}&direction=${sortDirection}`;
    }

    history.push({
      pathname: PAGES.LYNX_CONNECT_LOCATIONS,
      search: params,
    });
  };

  const allUserColumns = [
    {
      title: 'GID',
      dataIndex: 'gid',
      width: '50%',
      align: 'left',
      sorter: false,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text) => (
        <span style={{ cursor: 'pointer' }}>
          {text || <>&#8211;</>}
        </span>
      ),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      width: '50%',
      align: 'left',
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text) => (
        <span style={{ cursor: 'pointer' }}>
          {text || <>&#8211;</>}
        </span>
      ),
    },
  ];

  const internalUserColumns = [
    {
      title: 'GID',
      dataIndex: 'gid',
      width: '40%',
      align: 'left',
      sorter: false,
      // sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text) => (
        <span style={{ cursor: 'pointer' }}>
          {text || <>&#8211;</>}
        </span>
      ),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      width: '40%',
      align: 'left',
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text) => (
        <span style={{ cursor: 'pointer' }}>
          {text || <>&#8211;</>}
        </span>
      ),
    },
    {
      title: 'Lynx Location ID',
      dataIndex: 'lynxLocationId',
      width: '20%',
      align: 'left',
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (text) => (
        <span style={{ cursor: 'pointer' }}>
          {text || <>&#8211;</>}
        </span>
      ),
    },
  ];

  if (!Array.isArray(lynxTenantDetails)
    || lynxTenantDetails.length === 0
  ) {
    return <></>;
  }

  return (
    <Card>
      <Spin
        spinning={lynxConnectLoading}
        tip="Please wait..."
        size="large"
        delay={300} // delay in ms to avoid flicker
      >
        <RBAC permit={
          [ROLES.ADMINISTRATOR,
            ROLES.OWNER,
            ROLES.DEVELOPER,
            ROLES.OPERATIONS,
            // ROLES.ANALYST,
            ROLES.SUPPORT,
            ROLES.INTERNALSUPPORT,
            ROLES.POS,
            ROLES.SUPERUSER,
            ROLES.ONBOARDING,
            ROLES.OFFICEMANAGER,
            ROLES.OFFICESUPPORT,
            ROLES.WAREHOUSE_ASSOCIATE,
            ROLES.PRICING_ANALYST,
          ]
              }
        >
          <RBAC permit={
            [
              ROLES.INTERNALSUPPORT,
              ROLES.SUPERUSER,
              ROLES.ONBOARDING,
            ]
                }
          >
            <Row type="flex" justify="end">
              <Col>
                <SpButton
                  type="secondary"
                  shape="round"
                  className="mr-3 mb-3"
                  ghost
                  onClick={() => setModalVisibility(true)}
                >
                  {'\u002B'}&nbsp;New
                </SpButton>
              </Col>
            </Row>
          </RBAC>
          <Row>
            <RBAC permit={
              [ROLES.ADMINISTRATOR,
                ROLES.OWNER,
                ROLES.DEVELOPER,
                ROLES.OPERATIONS,
                // ROLES.ANALYST,
                ROLES.SUPPORT,
                ROLES.POS,
                ROLES.ONBOARDING,
                ROLES.OFFICEMANAGER,
                ROLES.OFFICESUPPORT,
                ROLES.WAREHOUSE_ASSOCIATE,
                ROLES.PRICING_ANALYST,
              ]
                  }
            >
              <Table
                columns={allUserColumns}
                rowKey={(record) => record.gid}
                dataSource={lynxConnectLocations}
                pagination={pagination}
                onChange={handleTableChange}
              />
            </RBAC>
            <RBAC permit={
              [
                ROLES.INTERNALSUPPORT,
                ROLES.SUPERUSER,
                ROLES.ONBOARDING,
              ]
                  }
            >
              <Table
                columns={internalUserColumns}
                rowKey={(record) => record.gid}
                dataSource={lynxConnectLocations}
                pagination={pagination}
                onChange={handleTableChange}
              />
            </RBAC>
          </Row>
          <Row>
            <AddNewLynxConnectLocation
              modalVisibility={modalVisibility}
              setModalVisibility={setModalVisibility}
              addNewLocation={addNewLocation}
              lynxConnectLoading={lynxConnectLoading}
            />
          </Row>
        </RBAC>
      </Spin>
    </Card>
  );
};

const mapStateToProps = state => ({
  loading: state.loading.loading,
  validator: state.loading.validator,
  selectedAccount: state.account.selectedAccount,
  submitting: state.loading.submitting,
  test: state.account.test,
  lynxTenantDetails: state.lynxTenantDetails.lynxTenantDetails,
  lynxConnectLocations: state.lynxConnect.locations.content,
  lynxConnectLocationsTotalElements: state.lynxConnect.locations.totalElements,
  lynxConnectLoading: state.lynxConnect.loading,
});

const mapDispatchToProps = dispatch => ({
  fetchLocations: param => dispatch(lynxConnectActions.fetchLocations({
    payload: param,
  })),
  addNewLocation: param => dispatch(lynxConnectActions.addNewLocation({
    payload: param,
  })),
  resetLocations: param => dispatch(lynxConnectActions.resetLocations({
    payload: param,
  })),
  fetchLynxTenantDetails: param => dispatch(lynxTenantDetailActions.fetchLynxTenantDetails({
    payload: param,
  })),
});

// $FlowFixMe
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LynxConnectInvoices));
